import { atom } from "recoil";

export const unreadMessageStore = atom<boolean>({
  key: "unreadMessage",
  default: false,
});
